import { type RootState } from '../rmsStore'

export default function getCustomerReducer (state: RootState): CustomerState   {
  return state.customersReducer
}
